module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/vantaggio_tecnologia.ec5a60c102a8e5187da60ccadb90786f.jpg";